
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { buildCommentUrl, prepareCommentText } from './utils';
import type { IPost, IPostComment } from '@/types/community';
import WarRoomAvatar from '@/components/partials/war-room/WarRoomAvatar.vue';
import { sortByFieldDesc } from '~/components/utils/sorting_func';

export default Vue.extend({
  name: 'WarRoomExposedComments',
  components: {
    WarRoomAvatar,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    comments(): IPostComment[] {
      return Object.values(this.post.popular_comments?.comment_dict || {})
        .sort(sortByFieldDesc('rating'))
        .map((comment: IPostComment) => {
          return {
            ...comment,
            url: this.getCommentUrl(comment.id),
            user: this.post.popular_comments?.user_dict[comment.user_username] || {},
            text: this.getCommentText(comment.text || ''),
          };
        });
    },
    commentsClasses(): Record<string, boolean> {
      return {
        'war-room-exposed-comments--disabled': !this.$auth.loggedIn,
        'war-room-exposed-comments--pinned': this.post.pinned,
      };
    },
  },
  methods: {
    getCommentUrl(commentId: number): string {
      return buildCommentUrl(this.post.slug, commentId);
    },
    getCommentText(text = ''): string {
      return prepareCommentText(text);
    },
    onClick(commentId: number): void {
      this.$analytics.logEvent(`war-room__post-preview__exposed-comment__click`, {
        postId: this.post.id,
        commentId,
      });
    },
  },
});
